import React, { useContext, useEffect, useRef, useState } from 'react'

import './StoryContent.scss'
import SoundWave from '../../SoundWave/SoundWave'
import useShortSounds from '../../SoundWave/useShortSounds'
import { useParams, useHistory, useLocation } from 'react-router-dom'
import Loader from '../Loader/Loader'
import { useTranslation } from 'react-i18next'
import { CHAPTERS, ROOMS } from '../../constants'
import { Texts } from './Texts'
import Icon from '../../assets/icons/Icon'
import { useElementEvent } from '../../hooks'
import Rooms from '../Rooms/Rooms'
import { UserClickedContext } from '../../App'
import ReactGA from 'react-ga'

const StoryContent = () => {
  let { name } = useParams()
  const activeChapter = CHAPTERS.find((ch) => ch.name === name).id
  const data = ROOMS[activeChapter].roomContent

  const { i18n, t } = useTranslation('common')
  const lng = i18n.language

  const [activeImg, setActiveImg] = useState(1)

  const [pause, setPause] = useState(false)

  const [navOpened, setNavOpened] = useState(false)

  const [waveImgLoaded, setWaveImgLoaded] = useState(false)

  const [bgSoundLoaded, setBgSoundLoaded] = useState(false)

  let location = useLocation()

  const disableNavigation = name === 'wool'

  const userClicked = useContext(UserClickedContext)

  useEffect(() => {
    ReactGA.pageview(location?.pathname + location?.search)
  }, [location])

  const arrowForthRef = useRef()
  const { shortSoundsLoaded, onPauseClick, sounds } = useShortSounds(
    data,
    bgSoundLoaded && userClicked,
    activeImg,
    setActiveImg,
    disableNavigation,
    arrowForthRef && arrowForthRef.current,
    pause,
    setPause
  )

  let history = useHistory()
  const onBackClick = () => {
    sounds[activeImg].fade(1, 0, 3000)
    setTimeout(() => {
      sounds[activeImg].unload()
    }, 3000)
    history.push(`/chapter?name=${name}`)
  }

  const soundsLoaded = bgSoundLoaded && shortSoundsLoaded

  const getImages = () => {
    if (soundsLoaded) {
      return (
        <div className="imgsWrapper">
          {data.map((item, i) => {
            if (item.text && !item.img) {
              return (
                <div key={i} className={`chapterText ${activeImg === i ? 'show' : ''}`}>
                  {Texts[lng][name]}
                </div>
              )
            }
            return (
              !!i && (
                <img
                  src={item.img}
                  alt="story"
                  className={`mainImg ${activeImg === i ? 'show' : ''} ${
                    activeImg === i || activeImg === i - 1 || activeImg === i + 1 || activeImg === i - 2
                      ? 'display'
                      : ''
                  }`}
                  key={i}
                />
              )
            )
          })}
        </div>
      )
    }
    return <Loader />
  }

  return (
    <>
      <div className="storyContent">
        <div className="contentWrapper">
          {getImages()}
          <div className="waveBlock">
            <SoundWave
              setWaveImgLoaded={setWaveImgLoaded}
              data={data}
              waveImgLoaded={waveImgLoaded}
              setBgSoundLoaded={setBgSoundLoaded}
              bgSoundLoaded={bgSoundLoaded}
              shortSoundsLoaded={shortSoundsLoaded}
              activeImg={activeImg}
              pageName={name}
              userClicked={userClicked}
            />
            {!disableNavigation && soundsLoaded && (
              <>
                <div className={`navButtons ${navOpened ? 'showNav' : ''}`}>
                  <Icon name="cross" stroke="black" onClick={() => setNavOpened(false)} className="crossIcon" />
                  {pause ? (
                    <Icon name="play" onClick={onPauseClick(false)} className="playIcon" />
                  ) : (
                    <Icon name="pause" className="pauseIcon" onClick={onPauseClick(true)} />
                  )}
                  <Icon
                    name="arrowRight"
                    stroke="black"
                    className="forthIcon"
                    ref={arrowForthRef}
                    style={{ opacity: pause ? 0.3 : 1, cursor: pause ? 'not-allowed' : 'pointer' }}
                  />
                </div>
                <Icon
                  name="plus"
                  onClick={() => setNavOpened(true)}
                  className={`plusBtn ${navOpened ? 'showNav' : ''}`}
                />
              </>
            )}
          </div>
          <div
            className={`back ${navOpened || (disableNavigation && soundsLoaded) ? 'showNav' : ''}`}
            onClick={onBackClick}
          >
            <Icon name="back" />
            <div>{t('return')}</div>
          </div>
        </div>
      </div>
      {shortSoundsLoaded && bgSoundLoaded && (
        <div id="tuneIn">
          <Icon name="play" />
          <span>{t('tuneIn')}</span>
        </div>
      )}
    </>
  )
}

export default StoryContent
